import { DOCUMENT, inject, Service } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { OrderService } from '@/pages/checkout-page/order.service';

/**
 * Pays an order on the Monobank page, for the amount the backend says is still due. The customer leaves
 * the site and comes back through the return URL the backend put in the invoice.
 */
@Service()
export class MonobankPaymentService {
  private readonly document = inject(DOCUMENT);
  private readonly orderService = inject(OrderService);

  /**
   * Stays open while the browser leaves the page. Completes when the customer comes back with the
   * Back button to this page restored as it was. Errors when the payment page cannot be created.
   */
  pay(orderIdExpanded: number): Observable<never> {
    return this.orderService.fetchMonobankPayment(orderIdExpanded)
      .pipe(switchMap(({ pageUrl }) => this.goTo(pageUrl)));
  }

  private goTo(pageUrl: string): Observable<never> {
    return new Observable<never>(subscriber => {
      const window = this.document.defaultView;
      const onPageShow = (event: PageTransitionEvent) => {
        if (event.persisted) {
          subscriber.complete();
        }
      };
      window?.addEventListener('pageshow', onPageShow);
      subscriber.add(() => window?.removeEventListener('pageshow', onPageShow));

      this.document.location.assign(pageUrl);
    });
  }
}
